<template>
  <section class="c-helpSection">
      <div class="main-container">
        <div class="content-container">
          <div class="c-helpSection__textContainer">
            <h2>How can we help?</h2>
            <h5>Our traveler support team are available 24/7 to help with any issues you may have. Email us at <span>support@flyairliberty.com</span>, use the widget on the bottom right of this page or check our help center.</h5>
            <Button name="Go to Help Center" color="blue" :transparent="true" link="https://d3v-flyairliberty.zendesk.com/hc/"></Button>
            <Button name="Contact us" color="blue" :transparent="true" link="mailto:support@flyairliberty.com"></Button>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
import Button from '@/components/Button'

export default {
  name: 'HelpSection',
  components: {
    Button
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.c-helpSection {
  .main-container {
    background-color: $light-blue;
  }
  .content-container {
    padding: 80px 0 60px 0;
    display: block;
  }

  &__textContainer {
    text-align: center;
    padding: 0 calc(#{$base-padding} * 9) calc(#{$base-padding} * 2) calc(#{$base-padding} * 9);

    h2 {
      font-weight: bold;
      padding-bottom: $base-padding;
    }

    h5 {
      margin-bottom: 50px;

      a {
        color: $blue;
        text-decoration: underline;
      }

      span {
        text-decoration: underline;
      }
    }

    button {
      margin-right: 30px;

      &:last-child {
        margin: 0;
      }
    }
  }
}

@include tablet {
  .c-helpSection {
    .content-container {
      padding: 40px 0 30px 0;
    }

    &__textContainer {
      text-align: center;
      padding: 0 calc(20px * 8) calc(20px * 2) calc(20px * 8);
    }

    h5 {
      font-size: 16px;
      line-height: 20px;
    }
  }
}

@include phone {
  .c-helpSection {
    .content-container {
      padding: 60px 0 60px 0;
    }

    &__textContainer {
      text-align: center;
      padding: 0;
    }

    button {
      display: block;
      margin: 0 auto calc(#{$base-margin} * 1.5) auto;

      &:last-child {
        margin: 0 auto;
      }
    }
  }
}
</style>
